function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  transform: "translate(-465 357)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  transform: "translate(465 -357)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_50",
  width: 38.157,
  height: 8.099,
  transform: "translate(0 43.344)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_51",
  width: 38.157,
  height: 8.098,
  transform: "translate(0 21.859)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_52",
  width: 38.157,
  height: 8.098,
  transform: "translate(0 0.372)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_9",
  transform: "translate(55.056)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  d: "M1018.372,406.613h10.26l23.7,31.142V406.613h10.982V457.19h-9.465l-24.493-32.152V457.19h-10.983Z",
  transform: "translate(-1018.372 -405.746)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_22",
  d: "M1095.122,431.841V431.7c0-14.378,11.2-26.155,26.517-26.155,9.1,0,14.6,2.457,19.87,6.937l-7.009,8.454c-3.9-3.252-7.369-5.13-13.221-5.13-8.093,0-14.523,7.153-14.523,15.752v.144c0,9.248,6.358,16.04,15.317,16.04a17.753,17.753,0,0,0,10.477-3.035v-7.225h-11.2v-9.61h21.966v21.965a32.829,32.829,0,0,1-21.6,8.02C1105.96,457.852,1095.122,446.8,1095.122,431.841Z",
  transform: "translate(-1033.059 -405.541)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  d: "M1193.191,406.166h10.26l21.676,50.939h-11.632l-4.624-11.344h-21.387l-4.625,11.344h-11.344Zm11.705,29.769-6.72-16.4-6.719,16.4Z",
  transform: "translate(-1047.677 -405.661)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  d: "M1249.606,431.841V431.7c0-14.378,11.2-26.155,26.517-26.155,9.1,0,14.594,2.457,19.869,6.937l-7.009,8.454c-3.9-3.252-7.37-5.13-13.222-5.13-8.093,0-14.523,7.153-14.523,15.752v.144c0,9.248,6.358,16.04,15.318,16.04a17.752,17.752,0,0,0,10.476-3.035v-7.225h-11.2v-9.61H1297.8v21.965a32.827,32.827,0,0,1-21.6,8.02C1260.443,457.852,1249.606,446.8,1249.606,431.841Z",
  transform: "translate(-1062.621 -405.541)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  d: "M1331.36,406.613h38.149v9.9h-27.094v10.26h23.844v9.9h-23.844v10.621h27.456v9.9H1331.36Z",
  transform: "translate(-1078.265 -405.746)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  d: "M1396.048,449.315l7.66-7.3c3.467,3.9,7.08,6.07,12.21,6.07,4.19,0,7.153-2.385,7.153-6.142V441.8c0-4.118-3.685-6.43-9.9-6.43h-4.625l-1.734-7.081,12.067-12.139h-19.869v-9.537h34.176v8.382l-12.789,12.21c6.864,1.156,13.584,4.769,13.584,14.162v.145c0,9.537-6.937,16.546-18.208,16.546C1406.669,458.057,1400.383,454.445,1396.048,449.315Z",
  transform: "translate(-1090.643 -405.746)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  d: "M1467.894,452.433c-3.685-3.685-6-9.1-6-19.147v-.145c0-15.607,7.081-27.6,22.182-27.6A23.429,23.429,0,0,1,1499.9,411.1l-5.853,8.6c-3.323-2.529-6-4.046-10.332-4.046-6.286,0-9.465,5.058-10.187,11.705a17.493,17.493,0,0,1,10.477-3.252c10.042,0,17.774,5.563,17.774,16.112v.145c0,10.333-8.309,17.485-19.291,17.485C1475.915,457.852,1471.434,455.974,1467.894,452.433Zm22.833-11.561v-.144c0-4.263-3.324-7.37-8.816-7.37s-8.669,3.035-8.669,7.3v.145c0,4.262,3.323,7.514,8.814,7.514S1490.727,445.208,1490.727,440.872Z",
  transform: "translate(-1103.244 -405.541)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  d: "M1529.98,431.841V431.7c0-14.667,9.1-26.155,22.543-26.155,13.368,0,22.4,11.344,22.4,26.012v.144c0,14.667-9.031,26.156-22.543,26.156S1529.98,446.508,1529.98,431.841Zm33.526,0V431.7c0-9.176-4.48-16.112-11.127-16.112s-10.983,6.72-10.983,15.968v.144c0,9.248,4.408,16.112,11.127,16.112S1563.505,441.017,1563.505,431.841Z",
  transform: "translate(-1116.272 -405.541)",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  d: "M1587.517,463.188v.307a2.309,2.309,0,0,0,.153.9,1.558,1.558,0,0,0,.41.578,1.578,1.578,0,0,0,.571.315,2.195,2.195,0,0,0,.637.095,3.044,3.044,0,0,0,.745-.088,1.507,1.507,0,0,0,.6-.292,1.45,1.45,0,0,0,.395-.534,1.956,1.956,0,0,0,.146-.8,1.427,1.427,0,0,0-.352-.981,3.844,3.844,0,0,0-.877-.716,12.519,12.519,0,0,0-1.141-.615,6.68,6.68,0,0,1-1.143-.688,3.714,3.714,0,0,1-.878-.93,2.358,2.358,0,0,1-.351-1.324,3.044,3.044,0,0,1,.235-1.236,2.526,2.526,0,0,1,.651-.9,2.773,2.773,0,0,1,.988-.549,4.021,4.021,0,0,1,1.228-.183,3.118,3.118,0,0,1,2.233.732,2.944,2.944,0,0,1,.7,2.356h-1.406a2.43,2.43,0,0,0-.328-1.391,1.434,1.434,0,0,0-1.3-.526,2.187,2.187,0,0,0-.593.081,1.492,1.492,0,0,0-.52.263,1.3,1.3,0,0,0-.373.483,1.724,1.724,0,0,0-.138.725,1.4,1.4,0,0,0,.351.974,3.8,3.8,0,0,0,.877.7q.528.315,1.142.615a7.04,7.04,0,0,1,1.142.7,3.492,3.492,0,0,1,.877.957,2.593,2.593,0,0,1,.352,1.4,3.192,3.192,0,0,1-.272,1.4,2.473,2.473,0,0,1-.719.908,2.752,2.752,0,0,1-1.041.49,5.255,5.255,0,0,1-1.254.146,3.377,3.377,0,0,1-1.8-.374,2.524,2.524,0,0,1-.924-.921,2.7,2.7,0,0,1-.337-1.113,8.713,8.713,0,0,1-.029-.958Z",
  transform: "translate(-1071.969 -415.11)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  d: "M1597.889,466.386h-1.258V455.821h2.18l2.663,8.868h.029l2.693-8.868h2.225v10.565h-1.346v-9.4h-.03l-2.956,9.4h-1.273l-2.9-9.4h-.03Z",
  transform: "translate(-1073.971 -415.162)",
  fill: "currentColor"
})));

var SvgEngage360 = function SvgEngage360(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 532.45 52.311",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEngage360, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/engage360.638fa3af.svg";
export { ForwardRef as ReactComponent };